import type { IServiceClient } from 'src/interfaces/serviceClient';
import type { TServiceClientVehicle } from 'src/interfaces/serviceClient';

/**
 * Extracts a flat list of vehicles from a service client.
 * Handles both array and single vehicle in service.vehicles.
 */
type VehicleItem = { vehicle: TServiceClientVehicle };

export const getVehiclesList = (client: IServiceClient | null): TServiceClientVehicle[] => {
    const raw = client?.service?.vehicles;
    const vehicles: Array<VehicleItem & { _id?: string }> = Array.isArray(raw)
        ? raw
        : raw
          ? [raw]
          : [];
    if (vehicles.length === 0) return [];
    const flattenedVehicles: TServiceClientVehicle[] = [];

    vehicles.forEach((item) => {
        if (!item?.vehicle) return;

        flattenedVehicles.push({
            ...item.vehicle,
            ...(item._id ? { serviceVehicleId: item._id } : {}),
        });
    });

    return flattenedVehicles;
};
